
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13274',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13274",
  "apollo-dlb": "static-3.86",
  "breeze-builder-lib": "static-1.827",
  "client-types": "static-1.498",
  "data-fetching-client": "static-1.9980",
  "foundations-components": "static-1.8522",
  "foundations-components-legacy": "static-1.1547",
  "foundations-theming": "static-1.4800",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.89",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8356",
  "hub-http-shared-msw-handlers": "static-1.10651",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11814",
  "I18n": "static-7.1678",
  "jasmine-runner": "static-1.6775",
  "marketplace-discovery-studio-lib": "static-1.669",
  "marketplace-storefront-base": "static-1.13337",
  "quartz": "static-1.7486",
  "react-dlb": "static-1.89",
  "react-rhumb": "static-1-fkhalid-populate-largest-shift-source.4",
  "reactive-variable-buffer-atom": "static-1.3182",
  "reporting-testing-lib": "static-1.10813",
  "reselect": "static-3.12",
  "settings-ui-lib": "static-1.12849",
  "SharedI18nStrings": "static-1.183",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7653",
  "ui-addon-i18n": "static-1.11471",
  "ui-addon-react-router-dom": "static-1.9859",
  "unified-auth": "static-1.950",
  "unified-auth-core-lib": "static-1.1232",
  "usage-tracker": "static-1.7639",
  "usage-tracker-core": "static-1.7489",
  "customer-data-property-utils": "static-1.8427",
  "hub-http": "static-1.6539",
  "integrations-lib": "static-1.17084",
  "marketplace-ui-common": "static-1.20773",
  "marketplace-ui-install": "static-1.759",
  "property-management-iframe": "static-1.14171",
  "quartz-config": "static-1.1264",
  "quartz-core": "static-1.6705",
  "quartz-routing": "static-1.916",
  "quick-fetch": "static-1.4147",
  "react": "static-7.196",
  "rpc-client-utils": "static-1.4991",
  "ts-schema": "static-1.4312",
  "ui-universal-auth": "static-1.9436",
  "UIComponents": "static-3.8760",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3763",
  "quartz-webpack": "static-1.3710",
  "bend-plugin-quartz-routing": "static-1.564",
  "ai-components-ui-library": "static-1.9759",
  "codemirror": "static-5.102",
  "foundations-assets": "static-1.5209",
  "pulse": "static-1.953",
  "react-codemirror": "static-1.10967",
  "ui-extensions-preview-lib": "static-1.641",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4791",
  "floating-ui": "static-1.63",
  "foundations-theming-specialty": "static-1.2516",
  "framer-motion": "static-1.79",
  "hs-story-utils": "static-1.9750",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.75",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5574",
  "react-virtualized": "static-2.107",
  "StyleGuideUI": "static-3.505",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2700",
  "ui-fonts": "static-1.1076",
  "ui-images": "static-2.1255",
  "bend-plugin-foundations-theming": "static-1.3283",
  "foundations-theming-base": "static-1.3785",
  "stylex": "static-1.41",
  "HeadJS": "static-2.800",
  "hs-test-utils-bend-plugin": "static-1.3467",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4637",
  "ui-addon-video-player": "static-1.9029",
  "ai-rendering-library": "static-1.11136",
  "chirp-fetch": "static-1.2220",
  "connections-embed-lib": "static-1.1541",
  "copilot-toolkit": "static-1.11877",
  "feedback-loader": "static-1.29841",
  "laboratory-lib": "static-3.7478",
  "marketplace-embed": "static-1.22952",
  "marketplace-ui-details": "static-1.10668",
  "marketplace-ui-reviews": "static-1.20728",
  "marketplace-ui-tracking": "static-1.14943",
  "sanitize-text": "static-1.8482",
  "usage-tracker-multi": "static-1.6053",
  "usage-tracker-session-replay": "static-1.5325",
  "wootric-nps": "static-1.7219",
  "quartz-head": "static-1.1151",
  "web-vitals": "static-1.15",
  "apollo-link-hub-http": "static-2.4981",
  "immer": "static-1.101",
  "immerable": "static-1.4474",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2702",
  "reporting-data": "static-1.68880",
  "cssUtils": "static-1.946",
  "flux-actions": "static-1.371",
  "react-colorpicker": "static-2.10541",
  "react-dnd-compat": "static-1.4941",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10695",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7629",
  "icons": "static-2.687",
  "marketplace-ui-apps-core": "static-1.19305",
  "storybook-react": "static-1.40",
  "trellis-story-utils": "static-1.4833",
  "foundations-components-test-utils": "static-1.6005",
  "quartz-i18n": "static-1.1161",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.500",
  "ads-unified-auth-lib": "static-1.1464",
  "generic-oauth-auth-lib": "static-1.78",
  "google-sheets-integration-lib": "static-1.1063",
  "microsoft-drive-auth-lib": "static-1.180",
  "surveymonkey-integration-lib": "static-1.521",
  "slack-ui-library": "static-1.10723",
  "fsm": "static-1.4076",
  "customer-data-objects": "static-1.8020",
  "property-translator": "static-1.5720",
  "hs-locale-management": "static-1.313",
  "frontend-preferences-client": "static-1.8246",
  "hs-promise-utils": "static-1.5919",
  "hubspot-apollo-client": "static-1.5200",
  "integrations-error-boundary-lib": "static-1.14499",
  "integrations-tracking-lib": "static-1.5934",
  "native-integrations-shared-strings": "static-1.8102",
  "sanitize": "static-1.4797",
  "superstore": "static-1.5082",
  "ui-shepherd-react": "static-3.10596",
  "ai-settings-ui-library": "static-1.8375",
  "hub-http-janus": "static-1.886",
  "hubspotter-http": "static-1.4881",
  "immutable-less": "static-1.4974",
  "marketplace-ui-client-types": "static-1.18180",
  "nav-meta": "static-1.30507",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18411",
  "ui-product-approvals-common": "static-1.1124",
  "ai-studio-lib": "static-1.12465",
  "hubspot-prosemirror": "static-1.19013",
  "integrations-reconnect-lib": "static-1.514",
  "ui-addon-iframeable": "static-1.9401",
  "ui-addon-integrations-directory-panel": "static-2.8353",
  "ui-product-approvals": "static-1.29229",
  "ui-tool-access": "static-1.10480",
  "inbound-db-properties-service-client": "static-1.4066",
  "property-management-common": "static-1.6459",
  "opentelemetry-fe-types": "static-1.103",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.580",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.478",
  "quartz-auth": "static-1.1161",
  "quartz-test": "static-1.1161",
  "quartz-tracking": "static-1.865",
  "trellis-components": "static-1.2719",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.401",
  "HubStyle": "static-2.12121",
  "bender-build-tools": "static-1.3452",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23120",
  "ContentUtils": "static-1.69159",
  "customer-data-objects-ui-components": "static-1.13356",
  "sassPrefix": "static-1.215",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.456",
  "batch-promise": "static-1.1869",
  "event-emitter": "static-1.1278",
  "fast-json-patch": "static-1.70",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5775",
  "magpie-types": "static-1.5235",
  "stylex-utils": "static-1.146",
  "trellis-theming": "static-1.1301",
  "avatar-components": "static-1.2807",
  "breeze-engine-core": "static-1.1070",
  "breeze-onboarding-components": "static-1.769",
  "customer-data-filters-ui": "static-1.40984",
  "customer-data-reference-ui-components": "static-1.13503",
  "embedded-academy-lib": "static-1.15581",
  "ExportDialog": "static-6.10704",
  "global-styles-ai-lib": "static-1.176",
  "highlight.js": "static-1.86",
  "marketplace-embed-ba": "static-1.655",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42094",
  "reporting-views-lib": "static-1.404",
  "reporting-snowflake": "static-1.57497",
  "reporting-ui-components": "static-2.66150",
  "reporting-visualizations": "static-1.60955",
  "trial-components-library": "static-1.14138",
  "ui-addon-teams": "static-1.21932",
  "upgrade-components-lib": "static-1.546",
  "navigation-components": "static-1.18870",
  "breeze-engine-lib": "static-1.1792",
  "simple-logging-lib": "static-1.3376",
  "fail-safe": "static-1.278",
  "app-governance-lib": "static-1.2425",
  "developer-experience-shared-components": "static-1.10864",
  "purchase-motions-components": "static-1.6390",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10321",
  "usage-tracker-anonymous": "static-1.6056",
  "usage-tracker-public": "static-1.7450",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.4026",
  "reference-resolvers": "static-1.8506",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4243",
  "hubspot-apollo-cache": "static-1.659",
  "universal-page-editor-lib": "static-1.3335",
  "final-form": "static-1.78",
  "redux-toolkit": "static-1.78",
  "simple-data-table": "static-1.3553",
  "merchandise-lib": "static-1.278",
  "ui-addon-draggable": "static-3.5082",
  "content-assistance-lib": "static-1.8227",
  "content-media-capture": "static-1.5475",
  "customer-data-ui-utilities": "static-1.10157",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24545",
  "growth-payments-core": "static-1.26222",
  "knowledge-content-types": "static-1.8671",
  "PatternValidationJS": "static-1.3217",
  "payment-link-components": "static-1.24196",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20333",
  "ui-addon-emoji-picker": "static-1.10210",
  "ui-business-units-lib": "static-1.9416",
  "video-components-external": "static-1.12178",
  "video-data-lib": "static-1.35836",
  "navigation-messaging": "static-1.8197",
  "collaboration-sidebar": "static-1.58760",
  "crm-component-utils": "static-1.39878",
  "crm-properties-common-lib": "static-1.6214",
  "customer-data-properties": "static-1.52650",
  "external-options-client-types": "static-1.4358",
  "framework-data-schema-resolvers": "static-1.7218",
  "property-value-citations": "static-1.3264",
  "reference-resolvers-lite": "static-1.8429",
  "opentelemetry-web": "static-1.15",
  "hubspotter-http-shared-msw-handlers": "static-1.10649",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "cms-field-types": "static-1.5139",
  "content-icons-ui": "static-1.2389",
  "atom": "static-1.5411",
  "idb-keyval": "static-1.51",
  "reactive-lib": "static-1.1043",
  "breeze-artifacts-sdk": "static-1.406",
  "getting-started-shared-tasks": "static-1.19282",
  "onboarding-journeys-lib": "static-1.969",
  "onboarding-scopes": "static-1.6778",
  "conversations-skeleton-state": "static-1.7573",
  "crm-message-bus": "static-1.43803",
  "customer-data-filters-ui-msw-helpers": "static-1.23419",
  "events-data-lib": "static-1.574",
  "FormUrlGenerator": "static-2.5051",
  "framework-builder-read-service-client": "static-1.4240",
  "hs-resources": "static-1.516",
  "multi-account-reference-resolvers": "static-1.1332",
  "onboarding-tours": "static-1.17139",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14501",
  "academy-common-lib": "static-1.15041",
  "dashboard-lib": "static-1.82890",
  "hubspot-prosemirror-plugins": "static-1.19005",
  "share-with-third-party-component-lib": "static-1.9034",
  "ui-asset-management-lib": "static-1.11424",
  "user-context": "static-1.5447",
  "report-customization-components": "static-1.13949",
  "reporting-enablement": "static-1.23865",
  "reporting-filters": "static-1.1031",
  "reporting-insights-lib": "static-1.2614",
  "zustand": "static-1.85",
  "reporting-plugins": "static-1.10781",
  "reporting-reports": "static-1.68557",
  "hubs-service-types": "static-1.1586",
  "purchase-motions-api": "static-1.6393",
  "salesImages": "static-1.587",
  "signup-constants": "static-1.19662",
  "nest": "static-1.561",
  "breeze-engine-chat-components": "static-1.770",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.229",
  "framework-listing-lib": "static-2.29534",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31475",
  "apps-service-types": "static-1.4066",
  "oauth-service-types": "static-1.4561",
  "signup-ui-url-generator": "static-2.8386",
  "onboarding-tours-client": "static-1.5354",
  "one-click-checkout": "static-1.441",
  "platform-infra-nav-components": "static-1.7911",
  "subscription-experience-data-types": "static-1.15259",
  "crm-record-cards-service-types": "static-1.3796",
  "location-customization-utils-lib": "static-1.10135",
  "redux-thunk": "static-2.80",
  "react-flip-move": "static-1.78",
  "ui-coaching-tips": "static-1.29341",
  "content-media-composition-data-lib": "static-1.13279",
  "fix-webm-duration": "static-1.30",
  "notification-sounds": "static-1.4750",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.769",
  "ui-addon-opt": "static-4.8690",
  "commerce-tours-lib": "static-1.6647",
  "growth-onboarding-reliability": "static-1.5406",
  "sales-checkout-service-client": "static-1.3855",
  "data-token-picker": "static-1.16917",
  "FileManagerLib": "static-1.40185",
  "content-media-compositions": "static-2.17286",
  "media-bridge-lib": "static-1.19431",
  "chatspot-widget-iframe": "static-1.23111",
  "collaboration-sidebar-common": "static-1.3557",
  "marketing-platform-lib": "static-1.7197",
  "card-properties-lib": "static-1.45048",
  "commerce-subscription-lib": "static-1.37821",
  "crm-actions": "static-1.6674",
  "crm-cards-sdk": "static-1.44626",
  "customer-data-properties-shared-msw-handlers": "static-1.9978",
  "customer-data-tracking": "static-1.7206",
  "calling-global-api": "static-1.65681",
  "calling-internal-common": "static-1.31647",
  "calling-lifecycle-internal": "static-1.67063",
  "calling-lifecycle-messages": "static-1.59357",
  "commerce-products-lib": "static-1.10573",
  "conditional-properties-service-client": "static-1.4034",
  "crm-index-visualization-core": "static-1.4570",
  "crm-links": "static-1.6657",
  "crm-pipelines-api-client-types": "static-1.4366",
  "formula-editor": "static-1.14797",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4446",
  "meetings-icalendar-utils-lib": "static-1.960",
  "multi-currency-client-types": "static-1.3927",
  "object-builder-ui-client": "static-1.49721",
  "pipeline-validation-client-types": "static-1.4201",
  "smart-data-capture-core": "static-1.174",
  "smart-property-lib": "static-1.8337",
  "tiered-pricing": "static-1.1988",
  "topics-actions-lib": "static-1.494",
  "ui-addon-form-validation": "static-1.11308",
  "fdsr-migration-layer": "static-1.337",
  "framework-data-schema-quick-fetch": "static-1.7123",
  "restore-request-side-panel-lib": "static-1.1712",
  "growth-data-modal": "static-1.5926",
  "growth-onboarding-confetti": "static-1.3387",
  "growth-onboarding-next-action-utils": "static-1.2723",
  "onboarding-tours-utils": "static-1.1206",
  "ui-shepherd-tracker": "static-1.7977",
  "academy-service-client": "static-1.4016",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40044",
  "SafeStorage": "static-1.4729",
  "video-embed": "static-1.36670",
  "redux-actions": "static-3.70",
  "EmailSignatureEditor": "static-1.25032",
  "viral-links-lib": "static-1.7402",
  "nested-table": "static-1.560",
  "timezone-utils": "static-2.5568",
  "getting-started-shared-tasks-store": "static-1.18400",
  "ui-addon-draggable-compat": "static-2.4587",
  "data-quality-ui-library": "static-1.13861",
  "html-to-image": "static-1.61",
  "segments-client-types": "static-1.11623",
  "campaign-roi-lib": "static-1.10328",
  "campaigns-utils-lib": "static-1.3544",
  "ui-addon-calendars": "static-2.5664",
  "customer-data-views-management": "static-1.26062",
  "framework-data-table": "static-2.12584",
  "nudge-client-utils": "static-1.3172",
  "nudge-custom-ui-functions": "static-1.1520",
  "switchboard-lib": "static-1.544",
  "access-check-ui-lib": "static-1.1623",
  "app-users-service-client": "static-1.5945",
  "app-users-service-types": "static-1.5353",
  "mini-checkout-client": "static-1.27536",
  "onboarding-utils": "static-1.5695",
  "permissions-shared-i18n-strings-fe": "static-1.2123",
  "ui-coaching-tips-shared-config": "static-1.29326",
  "checkout-sdk": "static-3.24379",
  "payment-method-components": "static-1.7172",
  "touchless-buying-components": "static-1.6247",
  "upgrade-catalog-service-types": "static-1.3795",
  "edison-service-client-types": "static-1.718",
  "growth-onboarding-feedback-components": "static-1.6909",
  "FileManagerImages": "static-1.37696",
  "video-components": "static-1.14180",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92876",
  "customer-data-sidebar": "static-2.46771",
  "enrichment-lib": "static-1.458",
  "universal-record-utils-lib": "static-1.2016",
  "commerce-billing-lib": "static-1.20231",
  "commerce-shared-components-lib": "static-1.19253",
  "commerce-tools-ui-lib": "static-1.11078",
  "crm-fe-perf": "static-1.23224",
  "calling-error-reporting": "static-1.31654",
  "shared-worker-versioning": "static-1.11367",
  "calling-usage-tracker": "static-1.6861",
  "voice-sms-access-library": "static-1.2099",
  "commerce-permissions": "static-1.1102",
  "products-iframe-lib": "static-1.8622",
  "products-ui-components-shared-msw-handlers": "static-1.11033",
  "crm-index-associations-lib": "static-1.6765",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10734",
  "sales-views-client-types": "static-1.4581",
  "bark-lib": "static-1.16838",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.676",
  "policy-lib": "static-1.7130",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10797",
  "onboarding-data-sync-lib": "static-1.2541",
  "growth-onboarding-next-action-components": "static-1.2751",
  "user-context-client": "static-1.4831",
  "audio-components": "static-1.6372",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4858",
  "outpost": "static-1.4478",
  "draft-convert": "static-2.80",
  "draft-extend": "static-3.83",
  "draft-js": "static-5.85",
  "draft-plugins": "static-2.22184",
  "sales-email-signature-service-client": "static-1.4171",
  "ts-utils-lib": "static-1.475",
  "merge-modal-lib": "static-1.12617",
  "crm-export-dialog": "static-1.6609",
  "crm-index-ui-shimmer": "static-1.2695",
  "crm-view-components": "static-1.1215",
  "react-beautiful-dnd": "static-1.70",
  "customer-data-associations": "static-1.7653",
  "tasks-actions-lib": "static-1.169",
  "nudge-custom-function-registry": "static-1.2929",
  "nudge-renderer-utils": "static-1.3248",
  "whisper-core-api": "static-1.7363",
  "InboxConnectUtils": "static-4.15594",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46881",
  "hub-http-rxjs": "static-1.851",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4316",
  "company-details-components": "static-1.6530",
  "react-performance-metrics-lib": "static-1.881",
  "pricing-pages-ui-components": "static-1.15899",
  "quote-checkout-service-types": "static-1.3778",
  "social-insights-client-types": "static-1.22706",
  "crm_universal": "static-1.22522",
  "customer-data-email": "static-1.18552",
  "card-payment-highlight-lib": "static-1.38016",
  "commerce-contract-lib": "static-1.13384",
  "invoices-highlight-card-lib": "static-1.55799",
  "orders-highlight-card-lib": "static-1.22229",
  "products-highlight-card-lib": "static-1.18856",
  "quotes-highlight-card-lib": "static-1.72850",
  "crm-source-interpretation-lib": "static-1.5655",
  "data-agent-utils": "static-1.520",
  "crm-object-search-query-utilities": "static-1.10223",
  "utility-belt": "static-1.2857",
  "payments-enrollment-embed-lib": "static-1.23879",
  "stripe-embedded-components": "static-1.8023",
  "customer-data-rte": "static-1.33678",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6305",
  "payments-post-enroll-local-storage-lib": "static-1.5430",
  "qrcode-generator": "static-1.76",
  "quotes-client-types": "static-1.38940",
  "calling-orchestration-schema": "static-1.36876",
  "react-reducer-toolkit": "static-1.16400",
  "meetings-connect-utils-lib": "static-1.7936",
  "tinymce-plugins": "static-1.58253",
  "hub-http-contrib": "static-1.3364",
  "ui-addon-sales-email": "static-1.5540",
  "access-control-lib": "static-1.10761",
  "EmailComponents": "static-1.55585",
  "EmailData": "static-1.54263",
  "redux-less": "static-2.9802",
  "company-details-service-types": "static-1.4267",
  "segments-query-core": "static-1.1749",
  "pricing-pages-api": "static-1.15764",
  "sequences-lib": "static-1.8558",
  "ui-gdpr-components": "static-1.10625",
  "products-ui-components": "static-1.41091",
  "accounting-integrations-ui-components": "static-1.7564",
  "invoices-ui-lib": "static-1.55815",
  "commerce-products-api": "static-1.2718",
  "invoices-iframe-lib": "static-1.57873",
  "quotes-modal-lib": "static-1.103528",
  "quotes-ui-lib": "static-1.81571",
  "stripe-connect-js": "static-1.78",
  "draft-content-plugins": "static-1.28936",
  "interframe": "static-3.5079",
  "layout-dnd-components": "static-1.12999",
  "layout-dnd-utils": "static-1.11974",
  "tinymce": "static-5.11",
  "tinymce-data": "static-1.41224",
  "tinymce-themes": "static-1.57109",
  "ui-brand-identity-lib": "static-1.16560",
  "ContentComponents": "static-2.72115",
  "ContentData": "static-1.69234",
  "marketing-email-service-types": "static-1.2105",
  "messaging-editing-lib": "static-1.47179",
  "messaging-usage-based-billing-components-lib": "static-1.2041",
  "automation-ui-source-apps": "static-1.19714",
  "automation-ui-types": "static-1.20632",
  "messaging-types-lib": "static-1.46916",
  "onboarding-settings-client": "static-1.4835",
  "sequences-client-types-lib": "static-1.8415",
  "commerce-tax-lib": "static-1.865",
  "price-books-api": "static-1.1765",
  "price-books-components": "static-1.1823",
  "property-description-translator": "static-1.4163",
  "ramp-editor": "static-1.922",
  "commerce-analytics-service-client": "static-1.3843",
  "totals-ui-components": "static-1.24325",
  "SalesContentIndexUI": "static-3.9646",
  "layout-data-lib": "static-1.10299",
  "NamespacedHubStyle": "static-2.9284",
  "advanced-menus-core": "static-1.15603",
  "advanced-menus-lib": "static-1.12477",
  "automation-ui-ubb": "static-1.6548",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7663",
  "data-token-views": "static-1.16898",
  "forms-utils-lib": "static-1.13120",
  "payments-embed-points-lib": "static-1.13619",
  "react-tinymce": "static-1.56013",
  "simple-menus-core": "static-1.15602",
  "simple-menus-lib": "static-1.17119",
  "tinymce-config": "static-2.55139",
  "ui-memberships-settings-lib": "static-1.34878",
  "videoconference-integration-components": "static-1.7312",
  "automation-applications-service-types": "static-1.3652",
  "automation-platform-service-types": "static-1.2663",
  "ContentEditorUI": "static-2.77947",
  "content-whatsapp-service-types": "static-1.578",
  "short-messages-app-service-client": "static-1.4243",
  "web-interactives-components": "static-1.14275",
  "web-interactives-data": "static-1.14276",
  "messaging-shared-utils-lib": "static-1.1490",
  "messaging-user-info-utils-lib": "static-1.1660",
  "email-portal-health-service-types": "static-1.1306",
  "line-items-api": "static-1.1123",
  "commerce-totals-service-types": "static-1.4051",
  "FireAlarmUi": "static-1.4743",
  "sales-templates-service-types-lib": "static-1.4402",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22568",
  "automation-ui-usage-tracking": "static-1.22031",
  "data-studio-ubb": "static-1.3545",
  "campaigns-lib": "static-1.27696",
  "content-management-data-lib": "static-1.5989",
  "copilot-plugins": "static-1.11849",
  "cta-picker": "static-1.37116",
  "customer-agent-discovery-components-lib": "static-1.3995",
  "editor-components": "static-1.13676",
  "editor-iframe-lib": "static-1.8825",
  "error-messaging-js": "static-1.5525",
  "FormsCommonComponents": "static-1.86611",
  "pictos": "static-7.191",
  "react-transition-group": "static-2.73",
  "redux-request-state": "static-1.10975",
  "SharedLegalStrings": "static-1.2068",
  "smart-content-core": "static-1.43209",
  "smart-content-lib": "static-1.43862",
  "social-composer-lib": "static-1.60327",
  "structured-content-lib": "static-1.25950",
  "theme-previewer-lib": "static-1.53949",
  "tinymce-copilot": "static-1.17207",
  "xray-recommendation-lib": "static-1.8287",
  "automation-ui-routing": "static-1.21989",
  "sql-reporting-client-types": "static-1.5908",
  "attribution-lib": "static-1.42823",
  "forms-ai-lib": "static-1.4790",
  "codemirror-dlb": "static-1.59506",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6765"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13274",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.827",
  "client-types": "/client-types/static-1.498",
  "data-fetching-client": "/data-fetching-client/static-1.9980",
  "foundations-components": "/foundations-components/static-1.8522",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1547",
  "foundations-theming": "/foundations-theming/static-1.4800",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.89",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8356",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10651",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11814",
  "I18n": "/I18n/static-7.1678",
  "jasmine-runner": "/jasmine-runner/static-1.6775",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.669",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13337",
  "quartz": "/quartz/static-1.7486",
  "react-dlb": "/react-dlb/static-1.89",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-populate-largest-shift-source.4",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3182",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10813",
  "reselect": "/reselect/static-3.12",
  "settings-ui-lib": "/settings-ui-lib/static-1.12849",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7653",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11471",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9859",
  "unified-auth": "/unified-auth/static-1.950",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1232",
  "usage-tracker": "/usage-tracker/static-1.7639",
  "usage-tracker-core": "/usage-tracker-core/static-1.7489",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8427",
  "hub-http": "/hub-http/static-1.6539",
  "integrations-lib": "/integrations-lib/static-1.17084",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20773",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.759",
  "property-management-iframe": "/property-management-iframe/static-1.14171",
  "quartz-config": "/quartz-config/static-1.1264",
  "quartz-core": "/quartz-core/static-1.6705",
  "quartz-routing": "/quartz-routing/static-1.916",
  "quick-fetch": "/quick-fetch/static-1.4147",
  "react": "/react/static-7.196",
  "rpc-client-utils": "/rpc-client-utils/static-1.4991",
  "ts-schema": "/ts-schema/static-1.4312",
  "ui-universal-auth": "/ui-universal-auth/static-1.9436",
  "UIComponents": "/UIComponents/static-3.8760",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3763",
  "quartz-webpack": "/quartz-webpack/static-1.3710",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.564",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9759",
  "codemirror": "/codemirror/static-5.102",
  "foundations-assets": "/foundations-assets/static-1.5209",
  "pulse": "/pulse/static-1.953",
  "react-codemirror": "/react-codemirror/static-1.10967",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.641",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4791",
  "floating-ui": "/floating-ui/static-1.63",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2516",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-story-utils": "/hs-story-utils/static-1.9750",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.75",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5574",
  "react-virtualized": "/react-virtualized/static-2.107",
  "StyleGuideUI": "/StyleGuideUI/static-3.505",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2700",
  "ui-fonts": "/ui-fonts/static-1.1076",
  "ui-images": "/ui-images/static-2.1255",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3283",
  "foundations-theming-base": "/foundations-theming-base/static-1.3785",
  "stylex": "/stylex/static-1.41",
  "HeadJS": "/HeadJS/static-2.800",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3467",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4637",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9029",
  "ai-rendering-library": "/ai-rendering-library/static-1.11136",
  "chirp-fetch": "/chirp-fetch/static-1.2220",
  "connections-embed-lib": "/connections-embed-lib/static-1.1541",
  "copilot-toolkit": "/copilot-toolkit/static-1.11877",
  "feedback-loader": "/feedback-loader/static-1.29841",
  "laboratory-lib": "/laboratory-lib/static-3.7478",
  "marketplace-embed": "/marketplace-embed/static-1.22952",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10668",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20728",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14943",
  "sanitize-text": "/sanitize-text/static-1.8482",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6053",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5325",
  "wootric-nps": "/wootric-nps/static-1.7219",
  "quartz-head": "/quartz-head/static-1.1151",
  "web-vitals": "/web-vitals/static-1.15",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4981",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4474",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2702",
  "reporting-data": "/reporting-data/static-1.68880",
  "cssUtils": "/cssUtils/static-1.946",
  "flux-actions": "/flux-actions/static-1.371",
  "react-colorpicker": "/react-colorpicker/static-2.10541",
  "react-dnd-compat": "/react-dnd-compat/static-1.4941",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10695",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7629",
  "icons": "/icons/static-2.687",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19305",
  "storybook-react": "/storybook-react/static-1.40",
  "trellis-story-utils": "/trellis-story-utils/static-1.4833",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6005",
  "quartz-i18n": "/quartz-i18n/static-1.1161",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.500",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1464",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.78",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1063",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.180",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.521",
  "slack-ui-library": "/slack-ui-library/static-1.10723",
  "fsm": "/fsm/static-1.4076",
  "customer-data-objects": "/customer-data-objects/static-1.8020",
  "property-translator": "/property-translator/static-1.5720",
  "hs-locale-management": "/hs-locale-management/static-1.313",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8246",
  "hs-promise-utils": "/hs-promise-utils/static-1.5919",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5200",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14499",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5934",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8102",
  "sanitize": "/sanitize/static-1.4797",
  "superstore": "/superstore/static-1.5082",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10596",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8375",
  "hub-http-janus": "/hub-http-janus/static-1.886",
  "hubspotter-http": "/hubspotter-http/static-1.4881",
  "immutable-less": "/immutable-less/static-1.4974",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18180",
  "nav-meta": "/nav-meta/static-1.30507",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18411",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1124",
  "ai-studio-lib": "/ai-studio-lib/static-1.12465",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19013",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.514",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9401",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8353",
  "ui-product-approvals": "/ui-product-approvals/static-1.29229",
  "ui-tool-access": "/ui-tool-access/static-1.10480",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4066",
  "property-management-common": "/property-management-common/static-1.6459",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.103",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.580",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.478",
  "quartz-auth": "/quartz-auth/static-1.1161",
  "quartz-test": "/quartz-test/static-1.1161",
  "quartz-tracking": "/quartz-tracking/static-1.865",
  "trellis-components": "/trellis-components/static-1.2719",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.401",
  "HubStyle": "/HubStyle/static-2.12121",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23120",
  "ContentUtils": "/ContentUtils/static-1.69159",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13356",
  "sassPrefix": "/sassPrefix/static-1.215",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.456",
  "batch-promise": "/batch-promise/static-1.1869",
  "event-emitter": "/event-emitter/static-1.1278",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5775",
  "magpie-types": "/magpie-types/static-1.5235",
  "stylex-utils": "/stylex-utils/static-1.146",
  "trellis-theming": "/trellis-theming/static-1.1301",
  "avatar-components": "/avatar-components/static-1.2807",
  "breeze-engine-core": "/breeze-engine-core/static-1.1070",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.769",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40984",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13503",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15581",
  "ExportDialog": "/ExportDialog/static-6.10704",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.176",
  "highlight.js": "/highlight.js/static-1.86",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.655",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42094",
  "reporting-views-lib": "/reporting-views-lib/static-1.404",
  "reporting-snowflake": "/reporting-snowflake/static-1.57497",
  "reporting-ui-components": "/reporting-ui-components/static-2.66150",
  "reporting-visualizations": "/reporting-visualizations/static-1.60955",
  "trial-components-library": "/trial-components-library/static-1.14138",
  "ui-addon-teams": "/ui-addon-teams/static-1.21932",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.546",
  "navigation-components": "/navigation-components/static-1.18870",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1792",
  "simple-logging-lib": "/simple-logging-lib/static-1.3376",
  "fail-safe": "/fail-safe/static-1.278",
  "app-governance-lib": "/app-governance-lib/static-1.2425",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10864",
  "purchase-motions-components": "/purchase-motions-components/static-1.6390",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10321",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6056",
  "usage-tracker-public": "/usage-tracker-public/static-1.7450",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.4026",
  "reference-resolvers": "/reference-resolvers/static-1.8506",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4243",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.659",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3335",
  "final-form": "/final-form/static-1.78",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "simple-data-table": "/simple-data-table/static-1.3553",
  "merchandise-lib": "/merchandise-lib/static-1.278",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5082",
  "content-assistance-lib": "/content-assistance-lib/static-1.8227",
  "content-media-capture": "/content-media-capture/static-1.5475",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10157",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24545",
  "growth-payments-core": "/growth-payments-core/static-1.26222",
  "knowledge-content-types": "/knowledge-content-types/static-1.8671",
  "PatternValidationJS": "/PatternValidationJS/static-1.3217",
  "payment-link-components": "/payment-link-components/static-1.24196",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20333",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10210",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9416",
  "video-components-external": "/video-components-external/static-1.12178",
  "video-data-lib": "/video-data-lib/static-1.35836",
  "navigation-messaging": "/navigation-messaging/static-1.8197",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58760",
  "crm-component-utils": "/crm-component-utils/static-1.39878",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6214",
  "customer-data-properties": "/customer-data-properties/static-1.52650",
  "external-options-client-types": "/external-options-client-types/static-1.4358",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7218",
  "property-value-citations": "/property-value-citations/static-1.3264",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8429",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10649",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "cms-field-types": "/cms-field-types/static-1.5139",
  "content-icons-ui": "/content-icons-ui/static-1.2389",
  "atom": "/atom/static-1.5411",
  "idb-keyval": "/idb-keyval/static-1.51",
  "reactive-lib": "/reactive-lib/static-1.1043",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.406",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19282",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.969",
  "onboarding-scopes": "/onboarding-scopes/static-1.6778",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7573",
  "crm-message-bus": "/crm-message-bus/static-1.43803",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23419",
  "events-data-lib": "/events-data-lib/static-1.574",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5051",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4240",
  "hs-resources": "/hs-resources/static-1.516",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1332",
  "onboarding-tours": "/onboarding-tours/static-1.17139",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14501",
  "academy-common-lib": "/academy-common-lib/static-1.15041",
  "dashboard-lib": "/dashboard-lib/static-1.82890",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19005",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9034",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11424",
  "user-context": "/user-context/static-1.5447",
  "report-customization-components": "/report-customization-components/static-1.13949",
  "reporting-enablement": "/reporting-enablement/static-1.23865",
  "reporting-filters": "/reporting-filters/static-1.1031",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2614",
  "zustand": "/zustand/static-1.85",
  "reporting-plugins": "/reporting-plugins/static-1.10781",
  "reporting-reports": "/reporting-reports/static-1.68557",
  "hubs-service-types": "/hubs-service-types/static-1.1586",
  "purchase-motions-api": "/purchase-motions-api/static-1.6393",
  "salesImages": "/salesImages/static-1.587",
  "signup-constants": "/signup-constants/static-1.19662",
  "nest": "/nest/static-1.561",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.770",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.229",
  "framework-listing-lib": "/framework-listing-lib/static-2.29534",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31475",
  "apps-service-types": "/apps-service-types/static-1.4066",
  "oauth-service-types": "/oauth-service-types/static-1.4561",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8386",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5354",
  "one-click-checkout": "/one-click-checkout/static-1.441",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7911",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15259",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10135",
  "redux-thunk": "/redux-thunk/static-2.80",
  "react-flip-move": "/react-flip-move/static-1.78",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29341",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13279",
  "fix-webm-duration": "/fix-webm-duration/static-1.30",
  "notification-sounds": "/notification-sounds/static-1.4750",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.769",
  "ui-addon-opt": "/ui-addon-opt/static-4.8690",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6647",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5406",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3855",
  "data-token-picker": "/data-token-picker/static-1.16917",
  "FileManagerLib": "/FileManagerLib/static-1.40185",
  "content-media-compositions": "/content-media-compositions/static-2.17286",
  "media-bridge-lib": "/media-bridge-lib/static-1.19431",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23111",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3557",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7197",
  "card-properties-lib": "/card-properties-lib/static-1.45048",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37821",
  "crm-actions": "/crm-actions/static-1.6674",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44626",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9978",
  "customer-data-tracking": "/customer-data-tracking/static-1.7206",
  "calling-global-api": "/calling-global-api/static-1.65681",
  "calling-internal-common": "/calling-internal-common/static-1.31647",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67063",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59357",
  "commerce-products-lib": "/commerce-products-lib/static-1.10573",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4034",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4570",
  "crm-links": "/crm-links/static-1.6657",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4366",
  "formula-editor": "/formula-editor/static-1.14797",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4446",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.960",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3927",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49721",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4201",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.174",
  "smart-property-lib": "/smart-property-lib/static-1.8337",
  "tiered-pricing": "/tiered-pricing/static-1.1988",
  "topics-actions-lib": "/topics-actions-lib/static-1.494",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11308",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.337",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7123",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1712",
  "growth-data-modal": "/growth-data-modal/static-1.5926",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3387",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2723",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1206",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7977",
  "academy-service-client": "/academy-service-client/static-1.4016",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40044",
  "SafeStorage": "/SafeStorage/static-1.4729",
  "video-embed": "/video-embed/static-1.36670",
  "redux-actions": "/redux-actions/static-3.70",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25032",
  "viral-links-lib": "/viral-links-lib/static-1.7402",
  "nested-table": "/nested-table/static-1.560",
  "timezone-utils": "/timezone-utils/static-2.5568",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18400",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4587",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13861",
  "html-to-image": "/html-to-image/static-1.61",
  "segments-client-types": "/segments-client-types/static-1.11623",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10328",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3544",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5664",
  "customer-data-views-management": "/customer-data-views-management/static-1.26062",
  "framework-data-table": "/framework-data-table/static-2.12584",
  "nudge-client-utils": "/nudge-client-utils/static-1.3172",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1520",
  "switchboard-lib": "/switchboard-lib/static-1.544",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1623",
  "app-users-service-client": "/app-users-service-client/static-1.5945",
  "app-users-service-types": "/app-users-service-types/static-1.5353",
  "mini-checkout-client": "/mini-checkout-client/static-1.27536",
  "onboarding-utils": "/onboarding-utils/static-1.5695",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2123",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29326",
  "checkout-sdk": "/checkout-sdk/static-3.24379",
  "payment-method-components": "/payment-method-components/static-1.7172",
  "touchless-buying-components": "/touchless-buying-components/static-1.6247",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3795",
  "edison-service-client-types": "/edison-service-client-types/static-1.718",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6909",
  "FileManagerImages": "/FileManagerImages/static-1.37696",
  "video-components": "/video-components/static-1.14180",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92876",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46771",
  "enrichment-lib": "/enrichment-lib/static-1.458",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2016",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20231",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19253",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11078",
  "crm-fe-perf": "/crm-fe-perf/static-1.23224",
  "calling-error-reporting": "/calling-error-reporting/static-1.31654",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11367",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6861",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2099",
  "commerce-permissions": "/commerce-permissions/static-1.1102",
  "products-iframe-lib": "/products-iframe-lib/static-1.8622",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11033",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6765",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10734",
  "sales-views-client-types": "/sales-views-client-types/static-1.4581",
  "bark-lib": "/bark-lib/static-1.16838",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.676",
  "policy-lib": "/policy-lib/static-1.7130",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10797",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2541",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2751",
  "user-context-client": "/user-context-client/static-1.4831",
  "audio-components": "/audio-components/static-1.6372",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4858",
  "outpost": "/outpost/static-1.4478",
  "draft-convert": "/draft-convert/static-2.80",
  "draft-extend": "/draft-extend/static-3.83",
  "draft-js": "/draft-js/static-5.85",
  "draft-plugins": "/draft-plugins/static-2.22184",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4171",
  "ts-utils-lib": "/ts-utils-lib/static-1.475",
  "merge-modal-lib": "/merge-modal-lib/static-1.12617",
  "crm-export-dialog": "/crm-export-dialog/static-1.6609",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2695",
  "crm-view-components": "/crm-view-components/static-1.1215",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.70",
  "customer-data-associations": "/customer-data-associations/static-1.7653",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.169",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2929",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3248",
  "whisper-core-api": "/whisper-core-api/static-1.7363",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15594",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46881",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.851",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4316",
  "company-details-components": "/company-details-components/static-1.6530",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.881",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15899",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3778",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "crm_universal": "/crm_universal/static-1.22522",
  "customer-data-email": "/customer-data-email/static-1.18552",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38016",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13384",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55799",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22229",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18856",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72850",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5655",
  "data-agent-utils": "/data-agent-utils/static-1.520",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10223",
  "utility-belt": "/utility-belt/static-1.2857",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23879",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8023",
  "customer-data-rte": "/customer-data-rte/static-1.33678",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6305",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5430",
  "qrcode-generator": "/qrcode-generator/static-1.76",
  "quotes-client-types": "/quotes-client-types/static-1.38940",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36876",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16400",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7936",
  "tinymce-plugins": "/tinymce-plugins/static-1.58253",
  "hub-http-contrib": "/hub-http-contrib/static-1.3364",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5540",
  "access-control-lib": "/access-control-lib/static-1.10761",
  "EmailComponents": "/EmailComponents/static-1.55585",
  "EmailData": "/EmailData/static-1.54263",
  "redux-less": "/redux-less/static-2.9802",
  "company-details-service-types": "/company-details-service-types/static-1.4267",
  "segments-query-core": "/segments-query-core/static-1.1749",
  "pricing-pages-api": "/pricing-pages-api/static-1.15764",
  "sequences-lib": "/sequences-lib/static-1.8558",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "products-ui-components": "/products-ui-components/static-1.41091",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7564",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55815",
  "commerce-products-api": "/commerce-products-api/static-1.2718",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57873",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103528",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81571",
  "stripe-connect-js": "/stripe-connect-js/static-1.78",
  "draft-content-plugins": "/draft-content-plugins/static-1.28936",
  "interframe": "/interframe/static-3.5079",
  "layout-dnd-components": "/layout-dnd-components/static-1.12999",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11974",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-data": "/tinymce-data/static-1.41224",
  "tinymce-themes": "/tinymce-themes/static-1.57109",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16560",
  "ContentComponents": "/ContentComponents/static-2.72115",
  "ContentData": "/ContentData/static-1.69234",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2105",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47179",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2041",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19714",
  "automation-ui-types": "/automation-ui-types/static-1.20632",
  "messaging-types-lib": "/messaging-types-lib/static-1.46916",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4835",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8415",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.865",
  "price-books-api": "/price-books-api/static-1.1765",
  "price-books-components": "/price-books-components/static-1.1823",
  "property-description-translator": "/property-description-translator/static-1.4163",
  "ramp-editor": "/ramp-editor/static-1.922",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3843",
  "totals-ui-components": "/totals-ui-components/static-1.24325",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9646",
  "layout-data-lib": "/layout-data-lib/static-1.10299",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9284",
  "advanced-menus-core": "/advanced-menus-core/static-1.15603",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12477",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6548",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7663",
  "data-token-views": "/data-token-views/static-1.16898",
  "forms-utils-lib": "/forms-utils-lib/static-1.13120",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13619",
  "react-tinymce": "/react-tinymce/static-1.56013",
  "simple-menus-core": "/simple-menus-core/static-1.15602",
  "simple-menus-lib": "/simple-menus-lib/static-1.17119",
  "tinymce-config": "/tinymce-config/static-2.55139",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34878",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7312",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3652",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2663",
  "ContentEditorUI": "/ContentEditorUI/static-2.77947",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.578",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4243",
  "web-interactives-components": "/web-interactives-components/static-1.14275",
  "web-interactives-data": "/web-interactives-data/static-1.14276",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1490",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1660",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1306",
  "line-items-api": "/line-items-api/static-1.1123",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4051",
  "FireAlarmUi": "/FireAlarmUi/static-1.4743",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4402",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22568",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22031",
  "data-studio-ubb": "/data-studio-ubb/static-1.3545",
  "campaigns-lib": "/campaigns-lib/static-1.27696",
  "content-management-data-lib": "/content-management-data-lib/static-1.5989",
  "copilot-plugins": "/copilot-plugins/static-1.11849",
  "cta-picker": "/cta-picker/static-1.37116",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3995",
  "editor-components": "/editor-components/static-1.13676",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8825",
  "error-messaging-js": "/error-messaging-js/static-1.5525",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86611",
  "pictos": "/pictos/static-7.191",
  "react-transition-group": "/react-transition-group/static-2.73",
  "redux-request-state": "/redux-request-state/static-1.10975",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2068",
  "smart-content-core": "/smart-content-core/static-1.43209",
  "smart-content-lib": "/smart-content-lib/static-1.43862",
  "social-composer-lib": "/social-composer-lib/static-1.60327",
  "structured-content-lib": "/structured-content-lib/static-1.25950",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53949",
  "tinymce-copilot": "/tinymce-copilot/static-1.17207",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8287",
  "automation-ui-routing": "/automation-ui-routing/static-1.21989",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5908",
  "attribution-lib": "/attribution-lib/static-1.42823",
  "forms-ai-lib": "/forms-ai-lib/static-1.4790",
  "codemirror-dlb": "/codemirror-dlb/static-1.59506",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6765"
}
};
